<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>{{$t('global.back')}}</span>
        </v-btn>

        <h1 class="mt-5 mb-3 text-center">{{$t('students.done_homework')}}</h1>

        <v-data-table :headers="headers"
                      :items="ATTACHMENTS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.link="props">
                <a :href="props.item.link" target="_blank" class="green--text" v-if="props.item.link">{{$t('students.online_editor')}}</a>
                <span class="green--text" v-else>-</span>
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-2" @click="[$refs.show.dialog = true, selectedNote = props.item.note]" v-if="props.item.note">
                    <svg v-svg="'icon-note'" size="12" class="mr-1" fill="#C14D00"></svg>
                    <span class="show">{{$t('students.show_note')}}</span>
                </v-btn>

                <v-btn text class="px-0 ml-2"
                       :class="!props.item.path.length ? 'cursor-default' : ''"
                       :href="props.item.path" target="_blank"
                       @click="checkError(props.item.path)"
                >
                    <svg v-svg="'icon-download'" size="12" class="mr-1"></svg>
                    <span class="green-text">{{$t('global.download')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <show ref="show" :note="selectedNote"></show>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Show from '@/components/Students/ShowNote';
    export default {
        components: { Show },
        data(){
            return {
                loadingRequest: false,
                selectedNote: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('homework.header'), sortable: false, value: 'title'},
                    {text: this.$t('students.link'), sortable: false, value: 'link', align: 'center'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: mapGetters(['ATTACHMENTS']),

        mounted() {
            this.getData();
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_ATTACHMENTS', this.$route.query.student_id)
                    .then(() => this.loadingRequest = false);
            },

            checkError(path){
                if(!path.length){
                    this.$store.dispatch('alert', {type: 2, message: this.$t('attach.no_attachment')});
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Users/Students/students";
</style>